import { InjectionToken } from '@angular/core';
import { Platform } from '../platform.service';
import { RealtimeMock } from './realtime-mock.service';
import { GlobalRTEConfig, IRealtimeClient, RealtimeClient, ServerRTEConfig, WebRTEConfig } from '@gains-com/realtime';
import { ILogger } from '../logger/logger-interface';

export const REALTIME = new InjectionToken<IRealtimeClient<WebRTEConfig, ServerRTEConfig & GlobalRTEConfig>>(
  'REALTIME',
);

export function realtimeProvider(
  platform: Platform,
  logger: ILogger,
): IRealtimeClient<WebRTEConfig, ServerRTEConfig & GlobalRTEConfig> {
  if (platform.isServer) {
    return new RealtimeMock();
  } else {
    return new RealtimeClient<WebRTEConfig, ServerRTEConfig & GlobalRTEConfig>(logger);
  }
}
